import axiosInstanceAI from "@/api/axiosInstanceAI";

export const fetchProfileApi = async ({
  contact_id,
  campaign_id = null,
  user_id,
}) => {
  try {
    const response = await axiosInstanceAI.post(`/prospect-profile/?user_id=${user_id}&contact_id=${contact_id}&campaign_id=${campaign_id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch profile. Please try again."
    );
  }
};
